import React from 'react'
import robotImg from '../../images/robotImg.png'

const PopupFour = ({onClose}) => {
  return (
     <div className="popup_overlay_po" onClick={onClose}>
      <div
        className="popup_container_po"
        onClick={(e) => e.stopPropagation()}
      >
        
        <div className="popup_content_po">
            
          <div className='greate_job_wrp_po'>
              <div className="mob_rob_wrp">
              
            <div className="robo_img_wrp robo_img_wrp_extra_height">
              <img src={robotImg} alt="" />
            </div>
            </div>
              <h3>Great Job! You Are All Set! </h3>
            <h3>Fastest Self-Service Implementation Ever!  </h3>
            <h3>Invite Friends & Earn 15% Every Month! </h3>
          </div>
        </div>
      </div>
      <div className="popup_right_po">
            <img
              src={robotImg}
              alt="robot"
              className="robot_img_po"
            />
          </div>
    </div>
  )
}

export default PopupFour